import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./muiCustomStyle.css";
import App from "./App.js";
import reportWebVitals from "./reportWebVitals.js";
import "./i18nConfig.js";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    const swPath = "/sw-v2.js";
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => {
          const activeUrl = registration?.active?.scriptURL || "";
          if (activeUrl.endsWith("/sw.js")) {
            registration.unregister();
          }
        });
      })
      .finally(() => {
        navigator.serviceWorker.register(swPath).catch((e) => {
          console.log("Service worker registration failed", e);
        });
      });
  });
}
